import { Button, ButtonProps } from '@mui/joy';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props extends ButtonProps {}

function SkipToMainContent(props: Props): JSX.Element {
  const { t } = useTranslation();
  // focus main content
  const handleSkipToContent = (e: React.MouseEvent<HTMLAnchorElement> | undefined): void => {
    e?.preventDefault();
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.scrollIntoView({ behavior: 'smooth' });
      mainContent.focus();
    }
  };

  return (
    <Button
      variant="link"
      size="sm"
      component="a"
      onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent> | undefined) => {
        handleSkipToContent(event);
      }}
      sx={{
        position: 'absolute',
        top: -50,
        left: '50%',
        translate: '-50%',
        zIndex: 999,
        margin: 'auto',
        ':focus': {
          top: 0,
          visibility: 'visible',
        },
      }}
      {...props}
    >
      {t('common.skip_to_content')}
    </Button>
  );
}

export default SkipToMainContent;
